import { Box } from "theme-ui";

export default function VideoHoverIcon() {
  return (
    <Box
      as="svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="black" />
      <path d="M9 7.5L16.5 12L9 16.5V7.5Z" stroke="white" strokeWidth="2" />
    </Box>
  );
}
